import { useTranslation } from 'next-i18next'
import type { GetStaticProps } from 'next'

import AuthLayout from 'components/Layouts/auth'
import SigninForm from 'components/SigninForm'
import { serverSideTranslations } from "next-i18next/serverSideTranslations"

// For deploy

const SignIn = () => {
  const { t } = useTranslation('auth')

  return (
    <AuthLayout title={t('titles.signin')}>
      <SigninForm />
    </AuthLayout>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale!, ['auth', 'common']))
    }
  }
}

export default SignIn
